import { render, staticRenderFns } from "./RedefinicaoSenhaView.vue?vue&type=template&id=65bc016e&scoped=true&"
import script from "./RedefinicaoSenhaView.vue?vue&type=script&lang=js&"
export * from "./RedefinicaoSenhaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bc016e",
  null
  
)

export default component.exports